import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NomeCombustivel} from "../model/AlteracaoCombustivel";

@Component({
  selector: 'app-menu-combustiveis',
  templateUrl: './menu-combustiveis.component.html',
  styleUrls: ['./menu-combustiveis.component.scss']
})
export class MenuCombustiveisComponent {
  @Output() alterarCombustivel = new EventEmitter<string>();
  @Input() listaCombustiveis: NomeCombustivel[] = []

  notificacaoTela = false;
  notificacaoMensagens: string[] = [];
  combustivelSelecionado: string = 'S';

  openGas(combustivel: string) {
    this.combustivelSelecionado = combustivel;
    this.alterarCombustivel.emit(combustivel);
  }

}
